import { Input } from "./ui/input";
import { TITOLI } from "../lib/anagConfig";

// Titolo modificabile: suggerimenti dalla lista standard + testo libero (es. "Prof.", "Rag.").
export default function TitoloInput({ value, onChange, testId, className = "" }) {
  const listId = `titoli-${testId}`;
  return (
    <>
      <Input value={value || ""} onChange={(e) => onChange(e.target.value)} list={listId} placeholder="Seleziona o scrivi…"
        data-testid={testId} className={className} autoComplete="off" />
      <datalist id={listId}>{TITOLI.map((t) => <option key={t} value={t} />)}</datalist>
    </>
  );
}
